import { getQueryValue } from "../../utils/url";
import { rangeToStartEnd } from "../../utils/cfi";
import pathToRegexp, { Key } from "path-to-regexp";

const path = "/embed/:vbid/:type?/:location*";
const keys: Key[] = [];
const regex = pathToRegexp(path, keys);
const result = regex.exec(`${window.location.pathname}${window.location.hash}`);
const keyMap: Record<string, string> = {};
if (result) {
  keys.forEach((cv, i) => {
    keyMap[cv.name] = result[i + 1];
  });
}

const getSnippetRange = () => {
  let cfi = getQueryValue("cfi");
  if (cfi && !Array.isArray(cfi)) {
    return rangeToStartEnd(cfi);
  }
  return null;
};

const validTypes = ["page", "pageid", "pages", "cfi", "epubcfi", "epub"];

function getDeepLinkUrl() {
  if (keyMap.type && validTypes.includes(keyMap.type) && keyMap.location) {
    return `/books/${keyMap.vbid}/${keyMap.type}/${keyMap.location}`;
  }
}

type ViewerContentParams = Pick<
  jigsaw.CreatePageViewerConfig,
  "vbid" | "start" | "end" | "url"
>;

export const getViewerContentParams = (): ViewerContentParams => {
  const snippet = getSnippetRange();
  return {
    vbid: keyMap.vbid,
    start: snippet ? snippet.start : undefined,
    end: snippet ? snippet.end : undefined,
    url: getDeepLinkUrl(),
  };
};

export const isValidBookUrl = () => {
  return !!keyMap.vbid;
};

export const getVbid = () => {
  return keyMap.vbid;
};
